import React from "react";

import { isRenewal } from "QuotePage/urls";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { calendlyURL, calendlyRenewalsURL } from "ZeroRuby/urls";

import Header from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { launchSalesforceChat } from "Common/salesforceChatApi";

import makeBem from "Utils/makeBem";

const bem = makeBem("HealthBenefitsModal");

const ANALYTICS_LOCATION = "compact_quote_page";
const FEATURE = "advantages_modal";

const AdvantagesModalBase = ({ show, onHide, companyProfile }) => (
  <Modal show={show} onHide={onHide} className={bem("modal")}>
    <ModalHeader closeButton>
      <Header level={7} mb={0}>
        Offer Health Benefits To Grow Your Business
      </Header>
    </ModalHeader>
    <ModalBody>
      <>
        <BodyText mb={2}>
          When you take into account contribution amounts and tax benefits, offering health insurance to your employees may be less expensive than you think.
          Small businesses that offer health insurance also have higher satisfaction ratings and are more likely to attract and retain talent.
        </BodyText>
        <BodyText mb={2}>
          Deciding to offer health insurance benefits can be daunting, which is why SimplyInsured focuses on making the process simple and straightforward.
          Other advantages include:
        </BodyText>
        <ol>
          <li>
            <BodyText>
              The most plans offered in the industry, which makes it easier to find a plan that fits your budget and helps you save money, while still staying
              competitive when recruiting new employees.
            </BodyText>
          </li>
          <li>
            <BodyText>Automatic deductions, applied to Quickbooks Payroll, which remove accounting headaches and inaccuracies</BodyText>
          </li>
          <li>
            <BodyText>
              A modern interface with access to world-class support gives you the ability to drive the process yourself or hand the wheel over to an expert to
              guide you through your journey.
            </BodyText>
          </li>
        </ol>
        <BodyText>Let us help guide you through the process.</BodyText>
        <Div>
          <Button
            color="link"
            p={0}
            mt={3}
            onClick={() => {
              window.Calendly.initPopupWidget({
                url: isRenewal() ? calendlyRenewalsURL() : calendlyURL(),
                prefill: {
                  name: companyProfile.contactName,
                  email: companyProfile.companyEmail,
                },
              });

              AnalyticsTracking.trackEvent("cta_clicked", {
                location: ANALYTICS_LOCATION,
                feature: FEATURE,
                type: "calendly_link_clicked",
                is_renewal: isRenewal(),
              });
            }}
          >
            <Icon icon="phone" pr={2} flavor="solid" />
            Book a 30 Minute Consultation
          </Button>
        </Div>
        <Div>
          <Button
            color="link"
            p={0}
            mt={3}
            onClick={() => {
              launchSalesforceChat();
              AnalyticsTracking.trackEvent("live_chat_clicked", {
                location: ANALYTICS_LOCATION,
                feature: FEATURE,
              });
            }}
          >
            <Icon icon="comments" pr={2} flavor="solid" />
            Live Chat with an Agent
          </Button>
        </Div>
      </>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onHide}>Return to Quote</Button>
    </ModalFooter>
  </Modal>
);

const mapStateToProps = (state) => ({
  companyProfile: state.companyProfile,
});

export default connect(mapStateToProps)(AdvantagesModalBase);
